import Vue from 'vue'
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.min.css'
import VueCookies from 'vue-cookies'
import VueGtag from 'vue-gtag'

import exchangeType from '@/lib/exchangeTypeHelper'
import socket from '@/lib/socket'
import api from '@/api'
import App from './App'
import router from './router'
import config from './config'
import plugins from './plugins'
import store from './store'
import i18n from './i18n'

Vue.use(VueMaterial)
Vue.use(VueCookies)
Vue.use(plugins)
Vue.use(socket)
Vue.use(exchangeType)

Vue.config.productionTip = false

Vue.material.locale = {
  ...Vue.material.locale,
  ...i18n.messages.en.material,
}

router.beforeEach(async (to, _, next) => {
  const isLoggedIn = JSON.parse(VueCookies.get('isLoggedIn'))
  const isLoginPath = to.path.includes('/login')

  if (isLoginPath && isLoggedIn) {
    next('/')
  }

  if (!isLoginPath && !isLoggedIn) {
    await api.session.info({ reload: false })
    VueCookies.set('isLoggedIn', true)
  }
  next()
})

if (config.ga.hasGoogleAnalytics && config.service.env === 'prod') {
  Vue.use(
    VueGtag,
    {
      config: {
        id: config.ga.trackingId,
        params: {
          send_page_view: false,
        },
      },
    },
    router
  )
}

const settingInfo = JSON.parse(localStorage.getItem('settingInfo')) || {}

function switchTheme(evt) {
  const matches = evt.matches ? 'dark' : 'light'
  const isNotAuto = settingInfo.appearance && settingInfo.appearance !== 'auto'
  const mode = isNotAuto ? settingInfo.appearance : matches

  Vue.material.theming.theme = `${config.platform.id}-${mode}`
  document.documentElement.style.setProperty(
    '--theme-color',
    `var(--md-theme-${config.platform.id}-${mode}-primary)`
  )
  document.getElementById('favicon').href = `/img/fav-${mode}.png`
}

const mediaQueryList = window.matchMedia('(prefers-color-scheme: Dark)')

switchTheme(mediaQueryList)

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
